import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=00f20220&scoped=true"
import script from "./ImageDialog.vue?vue&type=script&lang=ts"
export * from "./ImageDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImageDialog.vue?vue&type=style&index=0&id=00f20220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f20220",
  null
  
)

export default component.exports